import React, { Component } from 'react';
import CardSlider from '../../components/blog-cards/CardSlider';
import CardGrid from '../../components/blog-cards/CardGrid';
import arrow from '../../assets/images/icons/arrow-left.svg';
import CenterCard from './CenterCard';
import { api_url, headers } from '../../common/config';
import CenterLoader from '../../assets/images/loader/loader-center.svg';
import { withTranslation } from 'react-i18next';

class Centers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isClicked: false,
            centers: [],
            loaded: false,
        };
    }

    componentDidMount() {
        fetch(`${api_url}/autism/items/resources_page_centers`, {
            method: 'GET',
            // headers: headers,
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    centers: res.data,
                });
            });
    }

    handleClick = () => {
        this.setState({
            isClicked: true,
        });
    };

    render() {
        let cards = null;
        let centers = ['', '', '', '', ''];
        if (this.props.centers.length === 0 && this.props.filtered === false) {
            cards = centers.map((center) => (
                <div className='centers_card'>
                    <img src={CenterLoader} />
                </div>
            ));
        } else if (
            this.props.centers.length === 0 &&
            this.props.filtered === true
        ) {
            return (
                <div style={{ padding: '30px 55px' }}>
                    <h2>{this.props.t('noResults')}</h2>
                </div>
            );
        } else {
            cards = this.props.centers.map((center) => {
                return (
                    <CenterCard
                        image={center.image}
                        name={center.name}
                        location={center.location}
                        city={center.city}
                        district={center.district}
                        mobile={center.mobile}
                        phone={center.phone}
                        website={center.website}
                    />
                );
            });
        }

        const { t } = this.props;
        return (
            <div className='centers_container'>
                {this.props.isGrid ? (
                    <CardGrid arrow={arrow} cards={cards} />
                ) : (
                    <>
                        <div className='title_wrapper'>
                            <h2 className='title'>
                                {t('blog.centersSection')}
                            </h2>
                            <button onClick={this.props.showAllBtn}>
                                {t('blog.showAll')}
                            </button>
                        </div>
                        <CardSlider
                            arrow={arrow}
                            cards={cards}
                            size={30}
                            small
                        />
                    </>
                )}
            </div>
        );
    }
}

export default withTranslation()(Centers);
